var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "financing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M48,448h.968v.968H48Zm0,0",
    transform: "translate(-45.097 -420.903)",
    fill: "#0bb7a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M80,448h.968v.968H80Zm0,0",
    transform: "translate(-75.161 -420.903)",
    fill: "#0bb7a7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M112,448h.968v.968H112Zm0,0",
    transform: "translate(-105.226 -420.903)",
    fill: "#0bb7a7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M384,448h3.871v.968H384Zm0,0",
    transform: "translate(-360.774 -420.903)",
    fill: "#0bb7a7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M29.032,25.161V9.194a2.422,2.422,0,0,0-2.419-2.419H25.161a6.774,6.774,0,0,0-13.548,0H3.387A2.422,2.422,0,0,0,.968,9.194V25.161H0v2.419A2.422,2.422,0,0,0,2.419,30H27.581A2.422,2.422,0,0,0,30,27.581V25.161ZM26.613,7.742a1.453,1.453,0,0,1,1.452,1.452V25.161H27.1V9.677a.969.969,0,0,0-.968-.968H24.876a6.726,6.726,0,0,0,.208-.968ZM12.862,5,18,7.136l1.759,5.275A5.8,5.8,0,0,1,12.862,5Zm7.814,7.113L18.941,6.9l3.876-3.876a5.8,5.8,0,0,1-2.141,9.08ZM18.387.968a5.78,5.78,0,0,1,3.746,1.377L18.274,6.2,13.237,4.1A5.808,5.808,0,0,1,18.387.968ZM1.935,9.194A1.454,1.454,0,0,1,3.387,7.742h8.3a6.663,6.663,0,0,0,.208.968H3.871a.969.969,0,0,0-.968.968V25.161H1.935Zm27.1,18.387a1.454,1.454,0,0,1-1.452,1.452H2.419A1.454,1.454,0,0,1,.968,27.581V26.129h9.969a3.76,3.76,0,0,0,2.529.968h3.069a3.76,3.76,0,0,0,2.529-.968h6.1v-.968H18.671l-.142.142a2.8,2.8,0,0,1-1.995.826H13.465a2.8,2.8,0,0,1-1.995-.826l-.141-.142H3.871V9.677h8.4a6.759,6.759,0,0,0,12.222,0h1.631V26.129h2.9Zm0,0",
    fill: "#0bb7a7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M98.871,290.9a1.443,1.443,0,0,0-.8.244l-1.688-1.266a1.429,1.429,0,0,0,.073-.43,1.452,1.452,0,1,0-2.9,0,1.437,1.437,0,0,0,.086.473l-2.71,2.168a1.423,1.423,0,0,0-1.628.071l-2.086-1.391a1.42,1.42,0,0,0,.049-.354,1.452,1.452,0,0,0-2.9,0,1.42,1.42,0,0,0,.049.354l-2.086,1.391a1.436,1.436,0,0,0-.866-.293,1.452,1.452,0,1,0,1.452,1.452,1.419,1.419,0,0,0-.049-.354l2.086-1.391a1.424,1.424,0,0,0,1.731,0l2.086,1.391a1.423,1.423,0,0,0-.049.354,1.452,1.452,0,1,0,2.9,0,1.437,1.437,0,0,0-.086-.473l2.71-2.168a1.433,1.433,0,0,0,1.566-.022l1.688,1.266a1.43,1.43,0,0,0-.073.43,1.452,1.452,0,1,0,1.452-1.452Zm-17.419,2.9a.484.484,0,1,1,.484-.484A.485.485,0,0,1,81.452,293.806Zm4.355-2.9a.484.484,0,1,1,.484-.484A.485.485,0,0,1,85.806,290.9Zm4.355,2.9a.484.484,0,1,1,.484-.484A.485.485,0,0,1,90.161,293.806ZM95,289.935a.484.484,0,1,1,.484-.484A.485.485,0,0,1,95,289.935Zm3.871,2.9a.484.484,0,1,1,.484-.484A.485.485,0,0,1,98.871,292.839Zm0,0",
    transform: "translate(-75.161 -270.581)",
    fill: "#0bb7a7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M87.742,176H80v6.774h7.742Zm-.968,5.806H80.968v-4.839h5.806Zm0,0",
    transform: "translate(-75.161 -165.355)",
    fill: "#0bb7a7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M112,208h3.871v.968H112Zm0,0",
    transform: "translate(-105.226 -195.419)",
    fill: "#0bb7a7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M112,240h3.871v.968H112Zm0,0",
    transform: "translate(-105.226 -225.484)",
    fill: "#0bb7a7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M224,256h.968v.968H224Zm0,0",
    transform: "translate(-210.452 -240.516)",
    fill: "#0bb7a7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M256,256h9.677v.968H256Zm0,0",
    transform: "translate(-240.516 -240.516)",
    fill: "#0bb7a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancing);
export default __webpack_public_path__ + "static/media/financing.cfeb549b5fb1c7da2f83ca6c98db2287.svg";
export { ForwardRef as ReactComponent };